import { z } from 'zod';

const emailSchema = z.string().email();

export const checkIsValidateEmail = (email: string | null) => {
  if (!email) return false;
  return emailSchema.safeParse(email).success;
};
